import ahaGpt from './aha-gpt.module'

export default {
  ahaGpt,
}
